export const HIGHLIGHT_DURATION = 3000;
